import { LazyLoader, Modal } from '@bp/ui-components';
import { FragmentType } from 'client/gql';
import { GroupMessageForm, GroupMessageFormFragment } from 'components/Messages/forms/GroupMessageForm';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';

type GroupMessageModal = {
  isOpen: boolean;
  groupUuid: string;
  onClose: () => void;
  query: FragmentType<typeof GroupMessageFormFragment> | undefined;
};

export const GroupMessageModal = ({ isOpen, groupUuid, onClose, query }: GroupMessageModal) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal title={t('messages.newMessageForAll')} isOpen={isOpen} onRequestClose={onClose} loading={loading} width='s'>
      <Suspense fallback={<LazyLoader embedded transparent forceHeight='15vh' />}>
        <GroupMessageForm groupUuid={groupUuid} onLoad={setLoading} onClose={onClose} query={query} />
      </Suspense>
    </Modal>
  );
};
